import appConfig from '../../config'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import useAuth from '../../utils/hooks/useAuth'

const { unAuthenticatedEntryPath } = appConfig

const ProtectedRoute = () => {
    const { authenticated, authFlow } = useAuth()
    const location = useLocation()

    // If not authenticated or auth flow is not complete, redirect to sign in
    if (!authenticated || authFlow !== 'completed') {
        // Don't add redirect URL if user is on home page (likely signed out)
        // or if we're already on the sign-in page
        const shouldAddRedirect = location.pathname !== '/home' &&
            location.pathname !== '/sign-in' &&
            location.pathname !== '/'

        const redirectTo = shouldAddRedirect
            ? `${unAuthenticatedEntryPath}?redirect=${encodeURIComponent(location.pathname)}`
            : unAuthenticatedEntryPath

        return <Navigate replace to={redirectTo} />
    }

    return <Outlet />
}

export default ProtectedRoute
